import {
  resolveOrganizedTourDateRange,
  parseOrganizedTourDateInput,
} from "../../../utils/resolveOrganizedTourDateRange";

/**
 * @param {unknown} result — שורת חיפוש גולמית או VM עם raw
 * @returns {{ key: string, label: string, parts: { y: number, m: number, d: number } } | null}
 */
export function extractOrgTourDepartureDate(result) {
  if (!result || typeof result !== "object") return null;
  const row = result.raw && typeof result.raw === "object" ? result.raw : result;
  const dr = resolveOrganizedTourDateRange(row);
  const parts = parseOrganizedTourDateInput(dr.depRaw);
  if (!parts) return null;
  const y = parts.y;
  const m = parts.m;
  const d = parts.d;
  const key = `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
  const label = `${String(d).padStart(2, "0")}/${String(m).padStart(2, "0")}`;
  return { key, label, parts: { y, m, d } };
}

function keyToDdMmLabel(key) {
  if (typeof key !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(key)) return key;
  const [, mm, dd] = key.split("-");
  return `${dd}/${mm}`;
}

/**
 * צ׳יפי תאריכי יציאה מתוך רשימת VMs (תוצאות הטעינה — ללא פילטר צאצא).
 * @param {Array<Record<string, unknown>>} vms
 * @returns {{ chips: Array<{ key: string, label: string, count: number }>, detectedDates: string[] }}
 */
export function buildOrgTourDepartureDateChips(vms) {
  const rows = Array.isArray(vms) ? vms : [];
  const counts = new Map();
  for (const vm of rows) {
    const ex = extractOrgTourDepartureDate(vm);
    if (!ex?.key) continue;
    counts.set(ex.key, (counts.get(ex.key) || 0) + 1);
  }
  const detectedDates = [...counts.keys()].sort((a, b) => a.localeCompare(b));
  const chips = detectedDates.map((key) => ({
    key,
    label: keyToDdMmLabel(key),
    count: counts.get(key) || 0,
  }));

  if (import.meta.env?.DEV) {
    console.log("[ORG_TOUR_DEPARTURE_DATE_CHIPS_BUILD]", {
      totalResults: rows.length,
      detectedDates,
      chips: chips.map((c) => `${c.label} (${c.count})`),
    });
  }

  return { chips, detectedDates };
}
